import React, {HTMLAttributes} from 'react';
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import { OptionContainer, OptionLabel } from './FileSelectOption.styles';

interface FileSelectOptionProps {
    props: HTMLAttributes<HTMLLIElement>;
    option: any;
    onRemoveClick: (option: any) => void;
    isAdmin: boolean;
}

export const FileSelectOption = (fileSelectOptionProps: FileSelectOptionProps) => {
    const {props, option, onRemoveClick, isAdmin} = fileSelectOptionProps;

    return (
        <OptionContainer title={option.label} {...props}>
            <OptionLabel>
                {option.label}
            </OptionLabel>
            {isAdmin && (
                <IconButton size="small" onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    event.stopPropagation();
                    onRemoveClick(option);
                }}>
                    <DeleteIcon />
                </IconButton>
            )}
        </OptionContainer>
    );
}